import { IconDefinition } from "./types";

const arrowDownToBracket: IconDefinition = {
  iconName: "arrow-down-to-bracket",
  width: 448,
  height: 512,
  svgPathData:
    "M241 345l-17 17-17-17-136-136-17-17 33.9-33.9 17 17 95 95 0-270.1 48 0 0 270.1 95-95 17-17 33.9 33.9-17 17-136 136zM48 344l0 120 352 0 0-144 48 0 0 192-448 0 0-192 48 0 0 24z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "arrow-down-to-bracket",
  unicode: 0xe094,
};

export { arrowDownToBracket };
